// extracted by mini-css-extract-plugin
export default {"container":"LanguageIndicator_container__F6rlA","lang":"LanguageIndicator_lang__EZLgn"};